import { request } from '../sharedLegacy/utils'

// These endpoints are still on API v1, which only returns JSON when explicitly
// asked via `format=json&raw=1`. The new fetch layer no longer injects those, so
// we pass them here until these calls are migrated to `/api/2/...`.
const V1_JSON = { format: 'json', raw: '1' }

export const getLiveRealtimeData = (liveId, presenterToken) => {
  const url = '/api/live/realtime'
  const data = {
    live_id: liveId,
    ...V1_JSON,
  }

  if (presenterToken) {
    data.presenter_token = presenterToken
  }

  return request({
    url,
    method: 'GET',
    data,
  })
}

export const updateLive = (data = {}, liveId = undefined) => {
  return request({
    url: '/api/live/update',
    method: 'POST',
    data: {
      ...data,
      live_format: 'webinar',
      live_id: liveId,
      ...V1_JSON,
    },
  })
}
